import React, { useEffect } from "react";
import "./SessionExpiredModal.css";

const SessionExpiredHero = () => (
  <svg
    className="session-expired-hero"
    viewBox="0 0 240 200"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    fill="none"
  >
    <path
      d="M45 18 L60 18 L45 33 L60 33"
      stroke="#60a5fa"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.7"
    />
    <path
      d="M28 35 L38 35 L28 45 L38 45"
      stroke="#60a5fa"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.45"
    />
    <ellipse cx="118" cy="164" rx="92" ry="10" fill="#60a5fa" opacity="0.18" />
    <rect
      x="55"
      y="55"
      width="130"
      height="100"
      rx="10"
      fill="#0f1729"
      stroke="#60a5fa"
      strokeWidth="3"
    />
    <line x1="55" y1="76" x2="185" y2="76" stroke="#60a5fa" strokeWidth="2.5" />
    <circle cx="67" cy="65" r="2.5" fill="#60a5fa" />
    <circle cx="76" cy="65" r="2.5" fill="#60a5fa" />
    <circle cx="85" cy="65" r="2.5" fill="#60a5fa" />
    <circle cx="103" cy="108" r="4" fill="#60a5fa" />
    <circle cx="137" cy="108" r="4" fill="#60a5fa" />
    <path
      d="M105 122 Q120 135 135 122"
      stroke="#60a5fa"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle
      cx="195"
      cy="58"
      r="20"
      fill="#0f1729"
      stroke="#60a5fa"
      strokeWidth="3"
    />
    <g
      transform="translate(183 46)"
      stroke="#93c5fd"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15" />
    </g>
  </svg>
);

const SessionExpiredModal = ({ open }) => {
  useEffect(() => {
    if (!open) return undefined;
    const swallow = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", swallow, true);
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", swallow, true);
      document.body.style.overflow = overflow;
    };
  }, [open]);

  if (!open) return null;

  const handleLogin = () => {
    window.location.href = "/login";
  };

  return (
    <div
      className="session-expired-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="session-expired-modal">
        <SessionExpiredHero />
        <h2 id="session-expired-title" className="session-expired-title">
          Your session has expired
        </h2>
        <p className="session-expired-message">
          You will be redirected now to the login page...
        </p>
        <button
          type="button"
          className="session-expired-button"
          onClick={handleLogin}
          autoFocus
        >
          Log In Again
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
